import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import ExtraCurricular from "./extraCricular/extraCurricularActivity";

/**
 * AccountDetails Component for rendering both BankInformation and OtherAccountInformation Components
 */
class ExtraCurricularActivity extends Component {
  render() {
    return (
      <Container
        style={{ maxWidth: "60%", marginTop: "40px !important" }}
        className="card container-card migrator-mt personalDetails-div-1 contact-res"
      >
        <i
          className="material-icons contact-cancel-button pointer"
          onClick={this.props.back}
        >
          cancel
        </i>
        <Row>
          <Col md="12" className=" profile-contact-details-col mx-auto">
            <ExtraCurricular />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default  ExtraCurricularActivity;
